module.exports = __webpack_public_path__ + "img/guygirl.776e77d1.gif";